import React from 'react';
import { Modal } from 'react-bootstrap';

const Dialog = ({ backdrop = true, title, children, footer, show, handleClose, size }) => {
  return (
    <Modal
      backdrop={backdrop}
      size={size}
      centered
      show={show}
      onHide={() => handleClose && handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>{footer}</Modal.Footer>
    </Modal>
  );
};

export default Dialog;
